// Copyright 2026 The Gitea Authors. All rights reserved.
// SPDX-License-Identifier: MIT
import {createApp} from 'vue';

export async function initAgentValidation() {
  const el = document.querySelector<HTMLElement>('#agent-validation');
  if (!el) return;

  const pageData = window.config.pageData.agentValidation;
  if (!pageData) return;

  try {
    const {default: AgentValidation} = await import('../components/AgentValidation.vue');
    createApp(AgentValidation, {pageData}).mount(el);
    el.classList.remove('is-loading');
  } catch (err) {
    console.error('AgentValidation failed to load', err);
    el.textContent = 'Agent validation failed to load';
  }
}
